module.exports = __webpack_public_path__ + "static/gallery_treehouse_4-dab10858100f4c22dd6397ef913b1ba0.jpg";